import TabBar from './TabBar';
import TabContent from './TabContent';

const Tab = {
  Bar: TabBar,
  Content: TabContent,
};

export default Tab;
